import { render, staticRenderFns } from "./ItPrivacyPolicy.vue?vue&type=template&id=732d223e&scoped=true"
import script from "./ItPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./ItPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "732d223e",
  null
  ,true
)

export default component.exports